import { useState, useEffect } from "react";
import { Link } from "react-scroll";

function Navbar() {
  const [navActive, setNavActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem("theme") === "dark";
  });

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  const closeMenu = () => {
    setNavActive(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 500) {
        closeMenu();
      }
    };

    window.addEventListener("resize", handleResize);
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  // Apply theme on mount and when toggled
  useEffect(() => {
    const theme = isDark ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [isDark]);

  const toggleTheme = () => setIsDark((v) => !v);

  useEffect(() => {
    if (window.innerWidth <= 1200) closeMenu();
  });

  return (
    <nav
      className={`navbar ${navActive ? "active" : ""} ${scrolled ? "navbar--scrolled" : ""}`}
      role="navigation"
      aria-label="Main"
    >
      <div className="navbar-brand">
        <Link
          onClick={closeMenu}
          to="heroSection"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="brand-link"
        >
          <img src="/primary-logo.png" alt="Tech With Manny logo" className="brand-logo" />
          <span className="brand-text">Tech With Manny</span>
        </Link>
      </div>
      <button
        type="button"
        aria-label="Toggle navigation"
        aria-expanded={navActive}
        aria-controls="primary-nav"
        className={`nav__hamburger ${navActive ? "active" : ""}`}
        onClick={toggleNav}
      >
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
      </button>
      <div id="primary-nav" className={`navbar-items ${navActive ? "active" : ""}`}>
        <ul>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar-active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="heroSection"
              className="navbar-content"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar-active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="mySkills"
              className="navbar-content"
            >
              Skills
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar-active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="AboutMe"
              className="navbar-content"
            >
              About Me
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar-active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="MyPortfolio"
              className="navbar-content"
            >
              My Portfolio
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar-active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="testimonial"
              className="navbar-content"
            >
              Testimonials
            </Link>
          </li>
        </ul>
      </div>
      <div className={`navbar-items ${navActive ? "active" : ""}`}>
        <button type="button" className="btn theme-toggle" onClick={toggleTheme}>
          {isDark ? "Light Mode" : "Dark Mode"}
        </button>
        <Link
          onClick={closeMenu}
          activeClass="navbar-active-content"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          to="Newsletter"
          className="btn btn-outline-primary"
        >
          Subscribe
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
